<template>
  
  <div class="trding_view">
    <div class="kline_btns" v-show="Show">
      <div class="" v-show="isLine">
        <div class="resolutionbtns"  v-show="isEnough">
            <span v-for="item in btns" :key="item.res" :class="isActive===item.res?'selected':''" @click="getAny(item)">{{item.full}}</span>
        </div>
        <div class="resolutionbtns"  v-show="!isEnough">
          <span :class="isActive==='Time'?'selected':''"  @click="getAny({res:'Time'})">Time</span>
          
          <a-select
          :class="isActive==='1'||isActive==='5'||isActive==='15'||isActive==='30'?'active':''"
            :dropdownMenuStyle="{ backgroundColor: theme==='dark'?'#202F44':'#ffffff' }"
            ref="select"
            size="small"
            v-model="isActive"
            style="width: 45px"
            :defaultValue="isActive"
            @change="handleChange"
            optionFilterProp="children"
           >
           <a-icon slot="suffixIcon" type="caret-down" />
            <a-select-option :data-theme="theme" v-for="item in option1" :key="item.res" :value="item.res">
              {{ item.slug }}
            </a-select-option>
          </a-select>          
          <a-select
          :class="isActive2==='60'||isActive2==='120'||isActive2==='240'||isActive2==='360'||isActive2==='720'?'active2':''"
            :dropdownMenuStyle="{ backgroundColor: theme==='dark'?'#202F44':'#ffffff' }"
            ref="select"
            size="small"
            style="width: 45px"
            v-model="isActive2"

            :defaultValue="isActive2"
            @change="handleChange2"
            optionFilterProp="children"
           >
           <a-icon slot="suffixIcon" type="caret-down" />
            <a-select-option :data-theme="theme" v-for="item in option2" :key="item.res" :value="item.res">
              {{ item.slug }}
            </a-select-option>
          </a-select>

          <span :class="isActive3==='1440'?'selected':''"  @click="getAny({res:'1440',resolution:'1440'})">1Day</span>
          <span :class="isActive3==='10080'?'selected':''"  @click="getAny({res:'10080',resolution:'10080'})">1week</span>
          <span :class="isActive3==='44640'?'selected':''"  @click="getAny({res:'44640',resolution:'44640'})">1mon</span>
          

        </div>
      </div>
      <div class="kline_actions" v-show="isLine">
        <span @click="chartProperties">
          <a-tooltip>
            <template slot="title">
              {{$t('12934')}}
            </template>
            <a-icon type="setting" style="font-size: 16px;margin-top: 3px;"/>
          </a-tooltip>
        </span>
        <span @click="executeActionById">
          <a-tooltip>
            <template slot="title">
              {{$t('12935')}}
            </template>
            <a-icon type="stock" style="font-size: 16px;"/>
          </a-tooltip>
        </span>
        <span @click="showFullScreen" >
          <a-tooltip>
            <template slot="title">
              {{$t('12936')}}
            </template>
            <a-icon type="fullscreen"  style="font-size: 16px;"/>
          </a-tooltip>
        </span>
        <span @click="saveStudy">
          <a-tooltip>
            <template slot="title">
              {{$t('12937')}}
            </template>
            <a-icon type="save" style="font-size: 16px;"/>
          </a-tooltip>

        </span>
      </div>
      <div class="" style="flex: 1 1 0%; height: 24px; line-height: 24px; justify-content: flex-end;">
        <div class="kline_chartype">
          <span :class="isLine===true?'choose':''" @click="changeCharts('k')">
            {{$t('12932')}}
          </span>
          <span :class="isLine===true?'':'choose'" @click="changeCharts('d')">
            {{$t('12933')}}
          </span>
        </div>
      </div>
    </div>
    <a-spin size="large" v-show="!Show" class="loading" />
    <div class="" v-show="Show">

        <div class="ChartContainer" id="tv_chart_container" v-show="isLine"></div>
       
        <Depth v-show="!isLine"/>
    </div>
  </div>
</template>

<script>
import {mapState,mapActions, mapGetters} from 'vuex'
import TVjsApi from "./api/index";
import { klineConfig ,} from "@/utils/config";
import {message } from 'ant-design-vue';
import Depth from '@/components/Depthcontains/index.vue';

let jsApi = null; //图表配置项
export default {
  components: {
    Depth,
},
  data() {
    return {
      header_buttons:klineConfig.kline_btns,
      windowWidth:'',
      isEnough:true,
      limit: klineConfig.depthLimit,
      btns:[],
      isActive:'1m', // 当前按钮
      isActive2:'1H',
      isActive3:'',
      option1: [
        {
          resolution: "1",
          slug: "1m",
          full: "1min",
          res: "1",
        },
        {
          resolution: "5",
          slug: "5m",
          full: "5min",
          res: "5",
        },
        {
          resolution: "15",
          slug: "15m",
          full: "15min",
          res: "15",
        },
        {
          resolution: "30",
          slug: "30m",
          full: "30min",
          res: "30",
        },
      ],
      option2: [
        {
          resolution: "60",
          slug: "1H",
          full: "1hour",
          res: "60",
        },
        {
          resolution: "120",
          slug: "2H",
          full: "2hour",
          res: "120",
        },
        {
          resolution: "240",
          slug: "4H",
          full: "4hour",
          res: "240",
        },
        {
          resolution: "360",
          slug: "6H",
          full: "6hour",
          res: "360",
        },
        {
          resolution: "720",
          slug: "12H",
          full: "12hour",
          res: "720",
        },
      ],
      Show:false,
      b:[],
      s:[],
      maxAmount:[],
  
      lang:''
    };
  },
  computed: {
    ...mapState(['excnInfo','trade','symbol','depthData','local','country','theme','isLine','isShow']),
    ...mapGetters(['getShow']),
  },
  created(){
    // console.log(this.isLine);
    this.windowWidth= document.documentElement.clientWidth;
    if(this.windowWidth<1850){
      this.isEnough=false
    }else{
      this.isEnough=true
    }
    if(this.windowWidth<1850){
      let resoution=localStorage.getItem('tradingview.resolution')||15
      if(resoution<60){
        this.isActive= resoution
      }else if(resoution>= 60&&resoution<=720){
        this.isActive2=resoution
      }else{
        this.isActive3=resoution
      }
    }else {
     this.isActive =localStorage.getItem('tradingview.resolution')||15
    }

  },  
watch: {
  isShow:{
    immediate:true,
    handler(e){
      this.Show=e
    }
  },
  symbol(newData,oldData){
    let resolution=localStorage.getItem('tradingview.resolution')
    jsApi.switchtranspair(newData,oldData)
    jsApi.setSymbol(newData,resolution)
  },
  trade:{
    immediate:true,
    handler(e){
          if(e!==''){
            if(jsApi===null){
              setTimeout(() => {
              jsApi = new TVjsApi();
              jsApi.init(this.lang)
              }, 0);
            }
          }
      // if(this.isHaveCode&&oldData!==undefined&&e!==''){
      //     this.getTrade(trade,this.country)
      // }
    }
  },
  // country:{
  //   immediate:true,
  //   handler(e){
  //     if(e!==''){
  //       setTimeout(() => {
  //         jsApi = new TVjsApi();
  //         jsApi.init(this.lang)
  //       }, 0);
       
  //     }
  //   }
  // }
},
  methods: {
    ...mapActions(['setOrgList','setResolution','setIsLine','setIsShow']),
    showFullScreen(){
      jsApi.showFullScreen()
    },
    chartProperties(){
      jsApi.executeActionById('chartProperties')

    },
    executeActionById(){
      jsApi.executeActionById('insertIndicator')
    },
    getAny(item){
      if(this.windowWidth>=1850){
      this.isActive=item.res
      }
      if(item.resolution>720){
        this.isActive3=item.resolution
        this.isActive='1m'
        this.isActive2='1H'
      }
      if(item.res==='Time'){
      jsApi.changeChatType(3)
      }else{
        jsApi.changeChatType(1)
        localStorage.setItem('tradingview.resolution', item.resolution);
        this.setResolution('resolution',item.resolution)
        jsApi.chartSetResolution(item.resolution)
        // jsApi.init(TvConfigInfo); //图表初始化
      }

    }, 
    handleChange(e){
      this.isActive=e
      this.isActive2='1H'
      this.isActive3=''
      this.getAny({res:'1',resolution:e})
    } , 
    handleChange2(e){
      this.isActive2=e
      this.isActive='1m'
      this.isActive3=''

      this.getAny({res:'1',resolution:e})
    },
    saveStudy(){
      // localStorage.setItem('tvStudy')
      message.info('保存成功');
          // this.state.resolution +
          // this.props.chartType,
          // JSON.stringify(res)
        // message.info(this.props.intl.formatMessage({ id: "12938" }));
    },
    changeCharts(val){
      if(val==='k'){
        this.setIsLine({isLine:true})
        jsApi.executeActionById('timeScaleReset')
      }else{
        this.setIsLine({isLine:false})
        jsApi.executeActionById('timeScaleReset')

      }
    },
   
    
  },
  mounted() {
 
    // var that = this;
    // window.onresize = () => {
    // return (() => {
    // window.fullWidth = document.documentElement.clientWidth;
    // that.windowWidth = window.fullWidth; //获取屏幕宽度
    // })()
    
    // };
    this.setIsShow({isShow:false})
    if(!localStorage.getItem('tradingview.resolution')){
      localStorage.setItem('tradingview.resolution', '15');
    }
    this.header_buttons.map(item=>{
      if(item.option){
        item.option.map(n=>{
         this.btns.push(n)
        })
      }else{
        this.btns.push(item)
      }
    })  
      let local= location.href.split('/')[3]
      if(local!=='zh'&&local!=='zh-cn'&&local!=='en'&&local!=='ja'&&local!=='vi'&&local!=='id'){
      local='en'
    }
      if(local==='zh-cn'){
          this.lang='zh'
        }else if(local==='zh'){
          this.lang='zh_TW'
        }else if(local==='id'){
          this.lang='en'
        }else{
          this.lang=local
      }
  },

  beforeDestroy() {
    jsApi.destoryinstance().then(bool => {
      if (bool) {
        jsApi = null;
      }
    });
  }
};
</script>


<style lang="less" >
  #tv_chart_container {
    position: absolute;
    width: 100%;
    // height: 100%;
    height: calc(100% - 27px);
    // height: calc(100vh - 155px);
  }
  .depthContainer{
    width: 100%;
  }
  .trding_view { 
    .loading{
          // flex: ;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
    background: var(--grey800);
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
    .kline_btns {
      display: flex;
      height: 24px;
      border-bottom: 1px solid var(--line);
      padding: 0 8px 0 0;
      font-size: 12px;
      
      & > div:first-of-type {
        display: flex;
        & span:not([role="img"]) {
          color: var(--grey300);
  
          display: inline-block;
          min-width: 48px;
          text-align: center;
          height: 23px;
          line-height: 23px;
          cursor: pointer;
          margin-top: -1px;
        &.selected {
          background: var(--grey700);
          color: var(--yellow);
        }
          &:hover {
            color: #ffc300;
          }
          &:global(.selected) {
            color: #ffc300;
            background: var(--grey700);
          }
        }
        & p {
          min-width: 48px;
          text-align: center;
        }
      }
      & i {
        margin: 0 8px 0 0;
        cursor: pointer;
      }
      .resolutionbtns{
        display: flex;
        align-items: center;
        height: 100%;
         
        .ant-select {
            min-width: 20px;
            font-size: 10px;
            // color: #B0BFDB;
            background: var(--paperBg);
            .ant-select-selection__rendered{
              padding: 0 0 0 10px;
              margin: 0;
            }
            .ant-select-selection-selected-value{
              color: var(--grey300);
            }
            &:hover {
            // border: 1px solid #ffc300;
            color: #ffc300;
          }
          &:active{
            .ant-select-selection-selected-value{
                  color: var(--yellow);
                }
                background: var(--grey700);
              .ant-select-selection--single{
                background: var(--grey700);
              }
       
          }
          &:hover{
            .ant-select-selection-selected-value{
                  color: var(--yellow);
                }
                background: var(--grey700);
              .ant-select-selection--single{
                background: var(--grey700);
              }
          }
          &.active {
              .ant-select-selection-selected-value{
                  color: var(--yellow);
                }
                background: var(--grey700);
              .ant-select-selection--single{
                background: var(--grey700);
              }

            }
            &.active2{
              .ant-select-selection-selected-value{
                  color: var(--yellow);
                }
                background: var(--grey700);
              .ant-select-selection--single{
                background: var(--grey700);
              }

            }
            
          }
          
          .ant-select-selection--single {
            background-color: var(--grey800);
            border: none;
            width: 100%;
            height: 100%;
            &:hover{
              color: #ffc300;

            }
            
         }
 
          .ant-select-arrow {
           color: var(--grey200) !important;
           font-size: 9px;
           min-width: 5px !important;
           height: 5px !important;
           margin: 0 !important;
           position: absolute;
           right: -4px;
           top: 7px;
         }
                /* 去掉下拉框select 的聚焦样式  */
        .ant-select-open .ant-select-selection,
        .ant-select-focused .ant-select-selection, 
        .ant-select-selection:focus, 
        .ant-select-selection:active{
          box-shadow: none !important;
          border: none !important;
          border-width: none !important;
        }
      }
    }
    
    .kline_actions {
        > span {
          color: var(--grey300);
          margin: 0 8px 0 0;
          &:hover {
            color: var(--main);
          }
        }
      }
    .kline_chartype{
      float: right;
      display: flex;
      align-items: center;
      height: 100%;
      span {
        min-width: 52px !important;
        height: 18px !important;
        line-height: 14px !important;
        padding: 1px 8px;
        border: 1px solid var(--grey500);
        color: var(--grey300);
        font-size: 12px;
        border-radius: 2px;
        margin: 0 0 0 8px !important;
        cursor: pointer;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        overflow: hidden;
        &:hover {
          color: #ffc300;
        }
        &.choose {
          border-color: #ffc300;
          color: #ffc300;
        }
      }
  
    }

  }  


    .ant-select-dropdown-menu {
       text-align: left;
       font-size: 12px;
     }
        .ant-select-dropdown-menu-item {
          color: var(--grey200);
          padding: 0 0px 0 10px !important;
        }
        .ant-select-dropdown-menu-item:hover {
          background: var(--grey900) !important;
        }
        .ant-select-dropdown-menu-item-selected {
          background: var(--grey900) !important;
          color: #ffc300;
          padding: 0 0px 0 10px !important;
        }
        .ant-select-dropdown-menu-item-active {
          background: var(--grey900) !important;

        }
  </style>